import * as React from "react";
import Template from "@/module/data/texts/textTemplateModule";

const jaLang = {
  seeUbbDescription: (
    <>
      UBBは、私たちの身近なところに存在しています。
      そんなUBBをなくすために、SHISEIDOは、まず世の中に存在するUBBに目を向けることが大切だと考えています。
      <br />
      UBBを知るため、世界10カ国（オーストラリア、イタリア、ブラジル、中国、フランス、ドイツ、日本、タイ、アラブ首長国連邦、アメリカ）で調査を行い、5000のUBB体験談を収集しました。無意識の思い込みや偏見と、それらにより自分らしさを阻害されている人たちの本音の言葉です。
    </>
  ),
  risaTitle: "UBB(Unconscious Beauty Bias)実態調査監修",
  risaName: "Dr. Lisa D.Jenkins",
  profile: `Dr. Lisa D. Jenkinsは、30年以上の経験を持つ、モチベーショナルスピーカーです。人々が目的を持って変革をリードできるよう鼓舞することで知られている、ユニークなスタイルのセミナーやワークショップを数多く手がけています。`,
  comment: (
    <>
      「資生堂は150年にわたり、美のイノベーションに取り組んできました。そして今、世界中の人々を悩ませている「自分らしい美しさを制限する無意識の思い込みや偏見(以下
      UBB）」を変えるべく、新たな一歩を踏み出す時がきました。資生堂は世界10カ国の人々を対象とした大規模な調査を実施することで、UBBがもたらす影響を明らかにしました。グローバル社会の一員として、私たちは、人々が差別、いじめ、嫌がらせ、さらには暴力から解放され、本来の美しい人生を送ることができるよう、美の定義を進化させなければなりません。勇気を持って私たち自身の中に無意識に存在する固定概念を変えていくことが、不安や低い自尊心から解放されることにつながるのではないかと考えます。私たちは、自分が美しくない、と思わせてしまうような文化を変えなければなりません。
      <br />
      資生堂のミッションである、”Beauty Innovations for a better world
      “が示すように、美しさにイノベーションを起こし、美の定義を進化させることで、世界はより良い場所になると信じています。」
    </>
  ),
  title: (
    <>
      世の中に存在するUBBに
      <br />
      目を向けてみよう。
    </>
  ),
  ubbLink: "UBB一覧を見る",
  researchLink: "Unconscious Bias調査の概要について",
  modal: {
    Company: {
      title: "調査事務局",
      description: "株式会社博報堂",
    },
    Purpose: {
      title: "目的",
      description: "Unconscious Beauty Bias 証言の収集",
    },
    Period: {
      title: "調査期間",
      description: "2021/11/8-11/25",
    },
    Country: {
      title: "国",
      description:
        "10カ国（オーストラリア、イタリア、ブラジル、中国、フランス、ドイツ、日本、タイ、アラブ首長国連邦、アメリカ）",
    },
    Sample: {
      title: "サンプル数",
      description: "各国500 ＊10カ国5000証言",
    },
    Method: {
      title: "調査手法",
      description:
        "オンラインパネルによるインターネット調査、調査趣旨に同意いただいた方より自由回答形式にて証言を収集",
    },
    Subject: {
      title: "対象者条件",
      description: (
        <>
          下記何らかのUnconscious
          Bias(3５カテゴリー)を自分自身が感じたことがある。
          <br />
          （年齢、出生時に割り当てられた性別、性自認、自分が認識している性、性的指向性、肌の色、体格/体重/体型/体毛など
          、顔の造り/顔のパーツ（目の色・口の形など）、メイクアップ/化粧の仕方・有無、ファッション/服装/アクセサリー、髪/髪質、ボディアート/タトゥー、趣味（オタク・○○ファンなど）、食の嗜好性や飲酒、体臭・臭い、病歴/健康上の問題、障がいの有無(メンタル・身体的制限）、コミュニケーション能力/性格/行動（恥ずかしがり屋etc.）、交友関係(友達や属するグループ）、国籍、民族性/人種、出身地/住所/出生地、言語/アクセント/方言、姓名/家系/家族背景、婚姻状況/婚姻歴/離婚歴、子供の有無、妊婦・妊娠、家族関係（養子など含む）、自分の職業（職種）・肩書、親の職業、収入/所得水準、学歴・教育レベル、宗教、政治スタンス、自分の持ち物・資産（家・車・携帯など）、コロナ関連(マスク・ワクチン接種状況））
        </>
      ),
    },
    close: "閉じる",
  },
};

const enLang = {
  seeUbbDescription: (
    <>
      UBB exists as a part of our day to day life.
      <br />
      To eliminate UBB, SHISEIDO believes it is important to first acknowledge
      that it exists.
      <br />
      To learn more about UBB, we surveyed people in ten countries (Australia,
      Italy, Brazil , China, France, Germany, Japan, Thailand, UAE, US),
      collecting information about 5,000 UBB experiences. These are real words
      from real people who deal with assumptions and prejudices that inhibit
      them.
    </>
  ),
  risaTitle: "Supervisor of UBB(Unconscious Beauty Bias)Research",
  risaName: "Dr. Lisa D.Jenkins",
  profile: (
    <>
      Dr. Lisa D. Jenkins is a motivational and transformational speaker who has
      over 30 years of diverse experience. She is involved in many uniquely
      styled seminars and workshops that are known to inspire people to lead
      with purpose.
    </>
  ),
  comment: (
    <>
      “For 150 years, Shiseido has been committed to beauty innovation. As a
      result, the company is poised to dismantle the unconscious beauty biases
      that negatively impact individuals worldwide. After conducting an
      extensive survey of individuals in ten countries, Shiseido was able to
      clearly see the harmful implications of unconscious beauty biases. As part
      of a global community, we must redefine beauty so that people can live
      their true beautiful lives, free from discrimination, bullying, harassment
      and even violence. We must be courageous and committed to adjusting the
      lens of society, thereby freeing individuals from the depression, anxiety
      and low self-esteem that emerges because they do not feel they can sit,
      stand and walk in their own true beauty. We must change the culture that
      tells people they are less than beautiful.
      <br />
      Shiseido’s mission, beauty innovations for a better world, reminds us that
      it is never too late for us to innovate and redefine beauty – for a better
      world.”
    </>
  ),
  title: (
    <>
      Learn more about the UBB&nbsp;
      <br className={"display-sp"} />
      that exist in the world.
    </>
  ),
  ubbLink: "See ALL UBB.",
  researchLink: <>Overview of the Unconscious Bias Survey.</>,
  modal: {
    Company: {
      title: "Research company",
      description: "Hakuhodo Inc.",
    },
    Purpose: {
      title: "Research objective",
      description: "Gathering Unconscious Beauty Bias stories",
    },
    Period: {
      title: "Research period",
      description: "2021/11/8-11/25",
    },
    Country: {
      title: "Countries",
      description:
        "10 countries (Australia , Italy, Brazil , China, France, Germany, Japan, Thailand, UAE, US)",
    },
    Sample: {
      title: "Sample size",
      description: "500 samples per country * 10 countries = 5000 samples",
    },
    Method: {
      title: "Research method",
      description:
        "Internet survey by online panel, collecting samples in the form of free answers from those who agreed to the purpose of the survey.",
    },
    Subject: {
      title: "Conditions to qualify as participants",
      description: (
        <>
          Experienced 1 of the 35 UB categories below.
          <br />
          (Age, sex assigned at birth, gender identity, sex as perceived by
          self, sexual orientation, skin color, body size/weight/shape/hair,
          etc., facial structure/parts of face (eye color, mouth shape, etc.),
          make-up/application of make-up, fashion/clothing/accessories,
          hair/hair texture, body art/tattoos Hobbies , food preferences and
          alcohol consumption, body odor/odor, medical history/health problems,
          disabilities (mental or physical limitations), communication
          skills/personality/behavior (shyness, etc.), friendships (friends or
          groups to which you belong), nationality, ethnicity/race,
          hometown/address/birthplace, language/accent/dialect, last name
          Language/accent/dialect, family name/family lineage/family background,
          marital status/marital history/divorce history, presence of children,
          pregnant women/pregnancy, family relationships (including adopted
          children, etc.), one’s occupation (job title)/title, parents’
          occupation, income/income level, education/education level, religion,
          political stance, one’s possessions/assets (house, car, cell phone,
          etc.), covid-19 related (masks, vaccination status)
        </>
      ),
    },
    close: "Close",
  },
};

export default Template.selectLanguage(jaLang, enLang);
